export const RESERVED_TENANT_SLUGS = [
  'admin',
  'administrator',
  'tenant',
  'login',
  'forgot-password',
  'teacher',
  'student',
  'cas'
] as const

export const TENANT_SLUG_PATTERN = /^[a-z0-9][a-z0-9-]{1,63}$/

const reservedTenantSlugSet = new Set<string>(RESERVED_TENANT_SLUGS)

export function normalizeTenantSlug(value?: string | string[] | null): string {
  if (Array.isArray(value)) {
    value = value[0] ?? ''
  }
  if (typeof value !== 'string') {
    return ''
  }
  return value.trim().toLowerCase()
}

export function isTenantSlugReserved(value?: string | string[] | null): boolean {
  const normalized = normalizeTenantSlug(value)
  if (!normalized) {
    return false
  }
  return reservedTenantSlugSet.has(normalized)
}

export function isTenantSlugPatternValid(value?: string | string[] | null): boolean {
  const normalized = normalizeTenantSlug(value)
  if (!normalized) {
    return false
  }
  return TENANT_SLUG_PATTERN.test(normalized)
}

export function sanitizeTenantSlug(value?: string | string[] | null): string {
  const normalized = normalizeTenantSlug(value)
  if (!normalized || isTenantSlugReserved(normalized)) {
    return ''
  }
  return normalized
}

export interface TenantSlugValidationResult {
  normalized: string
  error?: string
}

export function validateTenantSlugInput(value?: string | string[] | null): TenantSlugValidationResult {
  const normalized = normalizeTenantSlug(value)
  if (!normalized) {
    return { normalized: '' }
  }
  if (!TENANT_SLUG_PATTERN.test(normalized)) {
    return { normalized: '', error: '学校标识仅支持小写字母、数字与中划线' }
  }
  if (isTenantSlugReserved(normalized)) {
    return { normalized: '', error: '该学校标识为系统保留关键字（如 cas），请使用学校专属地址' }
  }
  return { normalized }
}
